module.exports = __webpack_public_path__ + "static/media/arrow-down.f78db3ec.svg";